export default "__VITE_ASSET__D$$Wnh2M__"